import React from 'react';
import { Popover, } from '@mui/material';
import PermissionGateway from '../components/permission/PermissionGateway';
import { Link } from 'react-router-dom';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';


const RecursiveMenuPopover = ({ items, anchorEl, onClose, active = () => '' }) => {
    const [nestedAnchorEl, setNestedAnchorEl] = React.useState(null);
    const [nestedItems, setNestedItems] = React.useState([]);

    const open = Boolean(anchorEl);


    const handleSubItemHover = (event, item) => {
        if (item) {
            setNestedItems(item);
            setNestedAnchorEl(event.currentTarget);
        } else {
            setNestedAnchorEl(null);
            setNestedItems([]);
        }
    };

    const handleNestedClose = () => {
        setNestedAnchorEl(null);
        setNestedItems([]);
    };

    return (
        <>
            {
                open && items.length > 0 && (
                    <Popover
                        open={open}
                        anchorEl={anchorEl}
                        onClose={onClose}
                        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                        disablePortal={false}
                        keepMounted
                        slotProps={{
                            paper: {
                                sx: {
                                    maxHeight: '70vh',
                                    overflowY: 'auto',
                                    // top: '535px !important',
                                },
                            },
                        }}
                    >
                        <ul className="sidebar2 pl-0 my-1" style={{ listStyleType: "none" }} >
                            {items.map((item, index) => (
                                <li className={`nav-item nav-click ${active(`${item.checkUrl}`)}`} onClick={(e) => handleSubItemHover(e, item.children)}>
                                    <PermissionGateway
                                        moduleAlias={`${item.module}`}
                                        permissionAlias={`${item.permission || 'view'}`}
                                    >
                                        {item.url ? (
                                            <div onClick={() => onClose()}>
                                                <Link className="nav-link" to={item.url}>
                                                    <i className="menu-icon">{item.icon}</i>
                                                    <span className="menu-title">{item.label}</span>
                                                </Link>
                                            </div>
                                        ) : (
                                            <span className="nav-link" style={{ cursor: 'default' }}>
                                                <i className="menu-icon">{item.icon}</i>
                                                <span className="menu-title">{item.label}</span>
                                                <ChevronRightIcon className='ml-2' sx={{ width: 18, height: 18 }} />
                                            </span>
                                        )}
                                    </PermissionGateway>
                                </li >
                            ))}
                        </ul>
                    </Popover>
                )
            }


            {nestedItems.length > 0 && (
                <RecursiveMenuPopover
                    items={nestedItems}
                    anchorEl={nestedAnchorEl}
                    onClose={handleNestedClose}
                    active={active}
                />
            )}
        </>
    );
};

export default RecursiveMenuPopover;

